export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-v1-480-feeafe3145967db1eb35088ae50cac60.png";